<template>
    <section>
        <div class="bg-gradient-to-l from-theme1 to-theme2">
            <div class="container py-3 justify-between items-center flex flex-row">
                <LoadItemText class="text-white text-xl font-medium leading-7">
                    Loading Step..
                </LoadItemText>
                <div class="flex items-center justify-center flex-row gap-3">
                    <LoadItem v-for="(item, index) in 4"
                        :class="`w-[100px] rounded h-6 animation-delay-${index}00 max-sm:hidden ${index === 0 ? '!block' : ''}`" />
                </div>
            </div>
        </div>
        <div class="container py-6 pb-12">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
                <div class="col-span-2 gap-4 flex flex-col">
                    <LoadItemText class="text-gray-800 text-lg font-semibold leading-7">
                        Cart Loading
                    </LoadItemText>

                    <div class="overflow-x-auto">
                        <table class="table-auto w-full">
                            <thead class="text-sm font-semibold Capitalize text-slate-600 border bg-slate-50">
                                <tr>
                                    <th class="p-2 whitespace-nowrap">
                                        <div class="font-semibold text-left">
                                            No.
                                        </div>
                                    </th>
                                    <th class="p-2 whitespace-nowrap">
                                        <div class="font-semibold text-left">
                                            Product
                                        </div>
                                    </th>
                                    <th class="p-2 whitespace-nowrap">
                                        <div class="font-semibold text-center">
                                            Variant
                                        </div>
                                    </th>
                                    <th class="p-2 whitespace-nowrap">
                                        <div class="font-semibold text-center">
                                            Weight
                                        </div>
                                    </th>
                                    <th class="p-2 whitespace-nowrap">
                                        <div class="font-semibold text-center">
                                            Quantity
                                        </div>
                                    </th>

                                    <th class="p-2 whitespace-nowrap">
                                        <div class="font-semibold text-left">
                                            Sub Total
                                        </div>
                                    </th>
                                    <th class="p-2 whitespace-nowrap">
                                        <div class="font-semibold text-center">
                                            Action
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="text-sm text-slate-600 border">
                                <tr v-for="item in 3">
                                    <td colspan="7">
                                        <LoadContainer class="h-12 mb-2"></LoadContainer>
                                    </td>
                                </tr>

                            </tbody>


                        </table>

                    </div>

                </div>

                <LoadContainer class="h-[420px]"></LoadContainer>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import LoadContainer from './LoadContainer.vue';
import LoadItem from './LoadItem.vue';
import LoadItemText from './LoadItemText.vue';
</script>